import { z } from 'zod';
import { withPaginationParams, isMongoId } from '../../helpers';

export const ListKycRecordsInput = withPaginationParams(
  z.object({
    searchTerm: z.string().optional(),
    dateRange: z
      .object({
        startDate: z.string().optional(),
        endDate: z.string().optional(),
      })
      .optional(),
    firmId: z.string().optional(),
    archiveStatus: z.string().optional(),
  }),
  ['date', 'investor', 'status'],
);

export const UpdateKycStatusInput = z.object({
  investorId: z.string().refine(isMongoId()),
  isKyc: z.boolean(),
  approve: z.boolean(),
});

export const UpdateKycApprovalNoteInput = z.object({
  investorId: z.string().refine(isMongoId()),
  approvalNote: z.string(),
});

export const UnapproveAmlInput = z.object({
  investorId: z.string().refine(isMongoId()),
});
